/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyListItemDetail } from "./CompanyListItemDetail";
import {
  CompanyListItemDetailFromJSON,
  CompanyListItemDetailFromJSONTyped,
  CompanyListItemDetailToJSON,
  CompanyListItemDetailToJSONTyped,
} from "./CompanyListItemDetail";
import type { CompanyListSavedRoute } from "./CompanyListSavedRoute";
import {
  CompanyListSavedRouteFromJSON,
  CompanyListSavedRouteFromJSONTyped,
  CompanyListSavedRouteToJSON,
  CompanyListSavedRouteToJSONTyped,
} from "./CompanyListSavedRoute";

/**
 *
 * @export
 * @interface CompanyListDetail
 */
export interface CompanyListDetail {
  /**
   *
   * @type {string}
   * @memberof CompanyListDetail
   */
  companyListId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyListDetail
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CompanyListDetail
   */
  ownerEmail: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyListDetail
   */
  isOwner: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CompanyListDetail
   */
  isFollowing: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyListDetail
   */
  followers: Array<string>;
  /**
   *
   * @type {Array<CompanyListItemDetail>}
   * @memberof CompanyListDetail
   */
  items: Array<CompanyListItemDetail>;
  /**
   *
   * @type {CompanyListSavedRoute}
   * @memberof CompanyListDetail
   */
  route?: CompanyListSavedRoute | null;
  /**
   *
   * @type {string}
   * @memberof CompanyListDetail
   */
  columnConfig?: string | null;
}

/**
 * Check if a given object implements the CompanyListDetail interface.
 */
export function instanceOfCompanyListDetail(
  value: object,
): value is CompanyListDetail {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("ownerEmail" in value) || value["ownerEmail"] === undefined)
    return false;
  if (!("isOwner" in value) || value["isOwner"] === undefined) return false;
  if (!("isFollowing" in value) || value["isFollowing"] === undefined)
    return false;
  if (!("followers" in value) || value["followers"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function CompanyListDetailFromJSON(json: any): CompanyListDetail {
  return CompanyListDetailFromJSONTyped(json, false);
}

export function CompanyListDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyListDetail {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    name: json["name"],
    ownerEmail: json["ownerEmail"],
    isOwner: json["isOwner"],
    isFollowing: json["isFollowing"],
    followers: json["followers"],
    items: (json["items"] as Array<any>).map(CompanyListItemDetailFromJSON),
    route:
      json["route"] == null
        ? undefined
        : CompanyListSavedRouteFromJSON(json["route"]),
    columnConfig:
      json["columnConfig"] == null ? undefined : json["columnConfig"],
  };
}

export function CompanyListDetailToJSON(json: any): CompanyListDetail {
  return CompanyListDetailToJSONTyped(json, false);
}

export function CompanyListDetailToJSONTyped(
  value?: CompanyListDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    name: value["name"],
    ownerEmail: value["ownerEmail"],
    isOwner: value["isOwner"],
    isFollowing: value["isFollowing"],
    followers: value["followers"],
    items: (value["items"] as Array<any>).map(CompanyListItemDetailToJSON),
    route: CompanyListSavedRouteToJSON(value["route"]),
    columnConfig: value["columnConfig"],
  };
}
